import * as React from 'react'
import CardSection from './CardSection'
import { CampaignCardState, useGetCampaignCardsByStateQuery } from '/~/types/graphql'
import { normalizeNewApiCampaignCards, normalizeOldApiCampaignCards } from '/~/utils/campaignCard'
import { sortCampaignCards } from '/~/utils/arraySorting'
import { CardTypeEnum } from '/fiweb/components/CampaignCard/types'
import { PublishedCampaignCardState, useGetPublishedCampaignCardsByStateQuery } from '/~/types/issuer-graphql'
import { client } from '/~/lib/issuer-client/client'
import { useBreakpoint } from '/fiweb/lib'
import { getQueryDataFromURL } from '/~/utils/browserData'
import { Helmet } from '/~/components'

const ComingSoon = () => {
  const { medium, large } = useBreakpoint()
  const { data, loading } = useGetCampaignCardsByStateQuery({
    variables: { state: [CampaignCardState.COMING_SOON] },
    pollInterval: 300000,
    notifyOnNetworkStatusChange: true,
  })
  const { data: newApiData, loading: newApiLoading } = useGetPublishedCampaignCardsByStateQuery({
    variables: { state: [PublishedCampaignCardState.COMING_SOON] },
    pollInterval: 300000,
    skip: !client,
    notifyOnNetworkStatusChange: true,
    client,
  })

  const cardList = React.useMemo(
    () => [
      ...normalizeOldApiCampaignCards(data?.campaignCardsByState || []),
      ...normalizeNewApiCampaignCards(newApiData?.publishedCampaignCardsByState || []),
    ],
    [data, newApiData],
  )

  const cards = React.useMemo(() => sortCampaignCards(cardList || [], CardTypeEnum.COMING_SOON), [cardList])
  const size = cards.length

  const queryStringData = getQueryDataFromURL(location.search)
  const comingSoonSlug = queryStringData['kommer-snart']
  const comingSoonCard = comingSoonSlug ? cards.find((card) => card.slug === comingSoonSlug) : null

  if (!(loading || newApiLoading) && size === 0) {
    return null
  }

  return (
    <>
      {comingSoonCard && (
        <Helmet
          title={`Kommende emisjon i ${comingSoonCard.title}`}
          description={comingSoonCard.caption}
          url={`${window.location.origin}/kampanjer?kommer-snart=${comingSoonSlug}`}
          imageUrl={comingSoonCard.imageUrl}
        />
      )}
      <CardSection
        title='Kommende investeringsmuligheter'
        id='kommende-investeringsmuligheter'
        description='Følg emisjonene og få muligheten til å forhåndstegne.'
        name='comingSoon'
        loading={loading || newApiLoading}
        cards={cards}
        ignoreAdCard={!medium && cards.length % (large ? 2 : 3) === 0}
      />
    </>
  )
}

export default ComingSoon
